/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ISendEmailSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.SendEmailWorkflowBlock;
        isReadonly: boolean;
        emailConfigurations: Wars.Domain.Model.EmailConfiguration[];
        securityMatrixInfoLoaded: boolean;
        securityMatrix: Wars.Domain.Model.SecurityMatrix;
        changeHasSecurity(): void;
        securityMatrixService: services.SecurityMatrixService;
    }

    export class SendEmailSettingsModalController extends BaseModalController {

        constructor(
            private $scope: ISendEmailSettingsModalControllerScope,
            workflowBlock: models.SendEmailWorkflowBlock,
            private processConfigId: string,
            isReadonly: boolean,
            emailConfigurationService: services.EmailConfigurationService,
            systemLevelService: services.SystemLevelService,
            public securityMatrixService: services.SecurityMatrixService,
            workflowService: services.WorkflowService,
            close: any) {
            super($scope, close);
            this.$scope.workflowBlock = workflowBlock;
            this.$scope.isReadonly = isReadonly;
            this.$scope.securityMatrixService = this.securityMatrixService;
            this.$scope.changeHasSecurity = () => this.changeHasSecurity();

            this.$scope.emailConfigurations = [];
            systemLevelService.getSystemEmailConfigurations().then(
                (sysLevel) => {
                    this.$scope.emailConfigurations = this.$scope.emailConfigurations.concat(sysLevel.myEmailConfigurations);
                });

            emailConfigurationService.getAllEmailConfigurationsByProcessId(processConfigId)
                .then((emailConfigurations) => {
                    this.$scope.emailConfigurations = this.$scope.emailConfigurations.concat(emailConfigurations);
                });

            if (workflowBlock.sendEmailDto.securityMatrixId) {
                securityMatrixService.fetchById(workflowBlock.sendEmailDto.securityMatrixId, "SecurityMatrix")
                    .then((securityMatrix) => {
                        this.$scope.securityMatrix = securityMatrix;
                        this.$scope.securityMatrixInfoLoaded = true;
                    });
            }
        }

        public changeHasSecurity(): void {
          if (this.$scope.workflowBlock.sendEmailDto.hasSecurity) {
            var securityMatrix = this.$scope.securityMatrixService.createSecurityRowWithSubTypes(false);
            this.$scope.securityMatrix = securityMatrix;
            this.$scope.workflowBlock.sendEmailDto.securityMatrixId = securityMatrix.id;
            this.$scope.securityMatrixInfoLoaded = true;
            this.$scope.securityMatrixService.saveChanges([securityMatrix]);
          } else {
            this.$scope.workflowBlock.sendEmailDto.securityMatrixId = null;
          }
        }

    }
}

warsApp.registerController('SendEmailSettingsModalController', ['$scope', 'workflowBlock', 'processConfigId', 'isReadonly', 'emailConfigurationService', 'systemLevelService', 'securityMatrixService', 'workflowService', 'close']);